import React from "react";
import { Typography } from "@mui/material";
import VideoPlayer from "./videoPlayer";

interface VideoShowActionProps {
    action_value?: any;
}

export default function VideoShowAction({ action_value }: VideoShowActionProps) {
    const sanitizeVideoUrl = (value?: string) => {
        if (!value) return '';

        const withoutHtml = value
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/gi, ' ')
            .replace(/&amp;/gi, '&')
            .replace(/&quot;/gi, '"')
            .replace(/&#39;/gi, "'")
            .trim();

        const match = withoutHtml.match(/https?:\/\/[^\s"'<>]+/i);
        return match ? match[0] : withoutHtml;
    };

    return (
        <>
            {action_value && action_value.map((action: any, index: number) => {
                const videoSrc = sanitizeVideoUrl(action?.config_details?.default_value);

                return (
                    <div key={index} style={{ display: 'flex', marginBottom: '10px', flexDirection: 'column' }}>
                        <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
                            {action?.config_details?.value?.title || 'Video'}:
                        </Typography>
                        {videoSrc ? (
                            <VideoPlayer
                                src={videoSrc}
                                showLoopControls={action?.config_details?.value?.is_trim === 'true'}
                                format={action?.config_details?.value?.format}
                            />
                        ) : (
                            <p>Video not available.</p>
                        )}
                    </div>
                );
            })}
        </>
    );
}
